import { BlobServiceClient } from "@azure/storage-blob";

const containerName = `score-liderazgo`;
// const sasToken = "sp=racwdli&st=2023-04-03T11:41:44Z&se=2024-04-24T19:41:44Z&sv=2021-12-02&sr=c&sig=mdVXhYDronkI%2FCeTpqDfeOXni1Vh%2F46SPt77TV0kTJY%3D";
const sasToken = process.env.REACT_APP_AZURE_STORAGE_SAS_TOKEN;
const storageAccountName = process.env.REACT_APP_AZURE_STORAGE_RESOURCE_NAME;


// </snippet_package>

// <snippet_get_client>
const uploadUrl = `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`;
console.log(uploadUrl);

// get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
const blobService = new BlobServiceClient(uploadUrl);

// get Container - full public read access
const containerClient =
  blobService.getContainerClient(containerName);
// </snippet_get_client>

// <snippet_isStorageConfigured>
// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = () => {
  return !storageAccountName || !sasToken ? false : true;
};
// </snippet_isStorageConfigured>

// <snippet_getBlobsInContainer>
// return list of blobs in container to display
export const getBlobsInContainer = async () => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    console.log(`${blob.name}`);

    const blobItem = {
      url: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}?${sasToken}`,
      name: blob.name
    }

    // if image is public, just construct URL
    returnedBlobUrls.push(blobItem);
  }

  return returnedBlobUrls;
};

export const getBlobFile = async (filename) => {
  const blobClient = containerClient.getBlockBlobClient(filename);
  const downloadResponse = await blobClient.download();

  const downloaded = await blobToString(await downloadResponse.blobBody);

  // console.log("Downloaded blob content:", downloaded);

  const parsed = JSON.parse(downloaded);

  return parsed;

};

async function blobToString(blob) {
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onloadend = (ev) => {
      resolve(ev.target.result);
    };
    fileReader.onerror = reject;
    fileReader.readAsText(blob);
  });
}
// </snippet_getBlobsInContainer>

// <snippet_createBlobInContainer>
const createBlobInContainer = async (file, filename) => {
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(filename);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadData(file, options);
};
// </snippet_createBlobInContainer>

// <snippet_uploadFileToBlob>
const uploadFileToBlob = async (file, filename) => {
  if (!file) return;

  // upload file
  await createBlobInContainer(file, filename);
};
// </snippet_uploadFileToBlob>

export default uploadFileToBlob;